document.addEventListener('DOMContentLoaded', function () {
  // Trigger menu link for desktop
  const triggerMenuDesktop = document.querySelectorAll(
    '#desktop-menu > li.menu-item-has-children'
  );

  if (triggerMenuDesktop.length > 0) {
    // Transition duration
    const duration = 0.33;

    // Submenu starting position (Vertical Offset)
    const verticalOffset = 33;

    triggerMenuDesktop.forEach((triggerElement) => {
      // Pointer Enter
      triggerElement.addEventListener('pointerenter', function () {
        const subMenu = this.querySelector('ul.sub-menu');
        console.log('Pointer enter:', subMenu);

        if (subMenu) {
          gsap.to(subMenu, {
            startAt: {
              opacity: 0,
              y: verticalOffset,
            },
            duration: duration,
            opacity: 1,
            ease: 'power2.out',
            y: 0,
            onStart: () => {
              subMenu.classList.remove('hidden');
            },
          });
        }
      });

      // Pointer Leave
      triggerElement.addEventListener('pointerleave', function () {
        const subMenu = this.querySelector('ul.sub-menu');
        console.log('Pointer leave:', subMenu);

        if (subMenu) {
          gsap.to(subMenu, {
            opacity: 0,
            y: verticalOffset,
            duration: duration + 0.1,
            onComplete: () => {
              subMenu.classList.add('hidden');
            },
          });
        }
      });
    });
  } else {
    console.log('No trigger menu items found');
  }

  // Handle mobile menu toggle
  const mobileArrowLinks = document.querySelectorAll('.mobile-arrow-link');
  const duration = 0.33;

  mobileArrowLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const subMenu = this.closest('li').querySelector('.sub-menu');
      console.log('Mobile menu toggle:', subMenu);

      if (subMenu.classList.contains('hidden')) {
        gsap.to(subMenu, {
          startAt: {
            opacity: 0,
            height: 0,
          },
          duration: duration,
          opacity: 1,
          height: 'auto',
          ease: 'power2.out',
          onStart: () => {
            subMenu.classList.remove('hidden');
          },
          onComplete: () => {
            subMenu.style.height = 'auto';
          },
        });
      } else {
        gsap.to(subMenu, {
          opacity: 0,
          height: 0,
          duration: duration + 0.1,
          onComplete: () => {
            subMenu.classList.add('hidden');
            subMenu.style.height = '';
          },
        });
      }
    });
  });

  // Handle mobile menu button toggle
  const mobileMenuButton = document.querySelector(
    'button[aria-controls="mobile-menu"]'
  );
  const mobileMenu = document.getElementById('mobile-menu');

  mobileMenuButton.addEventListener('click', function () {
    if (mobileMenu.classList.contains('hidden')) {
      gsap.to(mobileMenu, {
        startAt: {
          opacity: 0,
          height: 0,
        },
        duration: duration,
        opacity: 1,
        height: 'auto',
        ease: 'power2.out',
        onStart: () => {
          mobileMenu.classList.remove('hidden');
        },
        onComplete: () => {
          mobileMenu.style.height = 'auto';
        },
      });
    } else {
      gsap.to(mobileMenu, {
        opacity: 0,
        height: 0,
        duration: duration + 0.1,
        onComplete: () => {
          mobileMenu.classList.add('hidden');
          mobileMenu.style.height = '0px';
        },
      });
    }
  });
});
